import styled from 'styled-components';

export const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  gap: 4px;
  background: #ffe8d5;
  color: #c76a1f;
  border: 1px solid #ffcba0;
  border-radius: 8px;
  padding: 4px 10px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
`;
